// Keep the original across page loads until its import is confirmed by the server.
const DB = 'sheet-stash', STORE = 'files';
export interface StashedFile { name: string; blob: Blob; id?: string }
function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
export async function stashFile(key: string, file: Blob & { name: string }, id: string = crypto.randomUUID()): Promise<StashedFile> {
  const db = await open();
  const value = { name: file.name, blob: file, id };
  try {
    await new Promise<void>((resolve, reject) => { const tx = db.transaction(STORE, 'readwrite'); tx.objectStore(STORE).put(value, key); tx.oncomplete = () => resolve(); tx.onabort = tx.onerror = () => reject(tx.error); });
    return value;
  } finally { db.close(); }
}
export async function readFile(key: string): Promise<StashedFile | null> {
  const db = await open();
  try {
    return await new Promise<StashedFile | null>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readonly'), req = tx.objectStore(STORE).get(key);
      tx.oncomplete = () => resolve(req.result ?? null);
      tx.onabort = tx.onerror = () => reject(tx.error);
    });
  } finally { db.close(); }
}
export async function forgetFile(key: string, id: string | undefined): Promise<void> {
  const db = await open();
  try {
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite'), store = tx.objectStore(STORE), req = store.get(key);
      // A different tab may already have queued another file for this document.
      req.onsuccess = () => { if (req.result?.id === id) store.delete(key); };
      tx.oncomplete = () => resolve(); tx.onabort = tx.onerror = () => reject(tx.error);
    });
  } finally { db.close(); }
}
